import { useTranslation } from 'react-i18next'
import { useThemeColors } from '@/contexts/ThemeContext'
import type { ModelInfo, ProviderType } from '@/lib/ai-providers'
import { theme } from '@/lib/theme'
import ProviderModelSelector from './ProviderModelSelector'

interface ChatHeaderProps {
  availableProviders: ProviderType[]
  selectedProvider: ProviderType | null
  selectedModel: string | null
  availableModels: ModelInfo[]
  isLoadingModels: boolean
  modelError: string | null
  onProviderChange: (provider: ProviderType) => void
  onModelChange: (modelId: string) => void
  currentSessionId: string
}

export default function ChatHeader({
  availableProviders,
  selectedProvider,
  selectedModel,
  availableModels,
  isLoadingModels,
  modelError,
  onProviderChange,
  onModelChange,
}: ChatHeaderProps) {
  const { t } = useTranslation()
  const colors = useThemeColors()
  return (
    <div
      style={{
        backgroundColor: colors.secondaryBg,
        borderBottom: `1px solid ${colors.primaryBorder}`,
        display: 'flex',
        gap: theme.spacing.sm,
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: availableProviders.length > 0 ? theme.spacing.sm : '0',
      }}
    >
      {availableProviders.length > 0 && (
        <ProviderModelSelector
          availableProviders={availableProviders}
          selectedProvider={selectedProvider}
          selectedModel={selectedModel}
          availableModels={availableModels}
          isLoadingModels={isLoadingModels}
          modelError={modelError}
          onProviderChange={onProviderChange}
          onModelChange={onModelChange}
        />
      )}
    </div>
  )
}
